import { Component, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../../shared'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-notification-active-users',
    templateUrl: './active-users.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarSearchComponent, WjGridModule, AutoSizeDirective, WjGridFilterModule],
})
export class NotificationActiveUsersComponent extends BaseComponent {
    usersGrid: Grid<any>
    activeTab = input(1)

    constructor() {
        super()

        this.usersGrid = new Grid<any>(this.services).wrapColumnHeaders().filterBy(item => [item.displayName])

        effect(() => {
            if (this.activeTab() === 3) this.refresh()
        })
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('api/Notification/GetActiveUsers')).subscribe({
                next: result => {
                    this.usersGrid.items = result[0]
                },
            }),
        )
    }
}
